import HeroSection from '../components/HeroSection';
import CategoryCarousel from '../components/CategoryCarousel';
import UpcomingEvents from '../components/UpcomingEvents';
import NewsletterSection from '../components/NewsletterSection';
import VenuesSection from '../components/VenuesSection';
import useSEO from '../hooks/useSEO';

export default function HomePage() {
  useSEO('Inicio', 'Descubre y compra boletos para los mejores eventos en Colombia. Conciertos, teatro, festivales, deportes y más en +Eventos.');
  return (
    <div style={{ maxWidth: '1440px', margin: '0 auto' }}>
      <HeroSection />
      <CategoryCarousel />
      <UpcomingEvents />
      <NewsletterSection />
      <VenuesSection />
    </div>
  );
}
